export default {
    parts: [
        'dssActionSection',
        'dssActionHeading',
        'notifyText',
        'descriptionText',
        'defaultWidth',
        'orderReceivedWidth',
        'orderShippedWidth',
        'dssActionButton',
        'dssActionButtonText'
    ],
    baseStyle: (props) => ({
        dssActionSection: {
            display: 'flex',
            flexDirection: 'column',
            gap: '16px'
        },
        dssActionHeading: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '16px', md: '20px'},
            fontWeight: '700',
            fontStyle: 'normal',
            textTransform: 'uppercase',
            lineHeight: {base: '20px', md: '24px'}
        },
        notifyText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12px', md: '14px'},
            fontWeight: '500',
            fontStyle: 'normal',
            lineHeight: {base: '18px', md: '20px'}
        },
        descriptionText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12px', md: '14px'},
            fontWeight: '400',
            fontStyle: 'normal',
            lineHeight: {base: '18px', md: '20px'}
        },
        dssActionButton: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            h: '48px',
            border: '1px solid gray.400',
            bg: 'white',
            textTransform: 'capitalize',
            padding: '12px',
            _hover: {bg: 'white'}
        },
        dssActionButtonText: {
            fontFamily: 'GarageNeue',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '8px',
            fontSize: {base: '12px', md: '14px'},
            lineHeight: '20px',
            fontWeight: '500',
            color: 'black'
        },
        policyLink: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12px', md: '14px'},
            fontWeight: '400',
            fontStyle: 'normal',
            lineHeight: {base: '18px', md: '20px'},
            width: 'fit-content',
            height: 'auto',
            textTransform: 'initial',
            backgroundColor: 'transparent',
            padding: '0',
            margin: '0',
            color: 'black',
            textDecoration: 'underline',
            marginBottom: '5px',

            _hover: {
                backgroundColor: 'transparent'
            }
        }
    })
}